var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-settings" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _c(
              "div",
              { ref: "messages" },
              [
                _vm.successMessage
                  ? _c("panel-info-box", { staticClass: "mab16" }, [
                      _c("p", { staticClass: "text-lg" }, [
                        _c("b", [_vm._v(_vm._s(_vm.successMessage))]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.errorMessage
                  ? _c("panel-info-box", { staticClass: "mab16" }, [
                      _c("p", { staticClass: "text-lg" }, [
                        _c("b", [_vm._v(_vm._s(_vm.errorMessage))]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lang-switcher mab16" },
              _vm._l(_vm.langs, function (lang) {
                return _c(
                  "button",
                  {
                    key: lang,
                    staticClass: "lang-switcher__btn",
                    class: {
                      "lang-switcher__btn--active": _vm.activeLang === lang,
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.activeLang = lang
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(lang.toUpperCase()) + " ")]
                )
              }),
              0
            ),
            _c("panel-competition-regulation-form", {
              key: _vm.activeLang,
              attrs: { saving: _vm.saving, removing: _vm.removing },
              on: { save: _vm.saveSettings, remove: _vm.removeStatute },
              model: {
                value: _vm.forms[_vm.activeLang],
                callback: function ($$v) {
                  _vm.$set(_vm.forms, _vm.activeLang, $$v)
                },
                expression: "forms[activeLang]",
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }